import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { formatApprovalPeriod } from '../../visit.approval.presentation';
import { VisitApprovalRecordRef } from '../../visit.approval.detail.model';

@Component({
  selector: 'wb-approval-period',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '{{ label() }}',
})
export class ApprovalPeriodComponent implements ICellRendererAngularComp {
  readonly label = signal('Not recorded');
  agInit(params: ICellRendererParams<VisitApprovalRecordRef>): void {
    this.label.set(formatApprovalPeriod(params.data));
  }
  refresh(params: ICellRendererParams<VisitApprovalRecordRef>): boolean {
    this.agInit(params);
    return true;
  }
}
